import * as Yup from 'yup';
import { isBefore } from 'date-fns';

export const getIntervalShape = () => ({
  warehouseId: Yup.number()
    .typeError('Selecione um armazém')
    .required('Selecione um armazém'),
  dockIds: Yup.array()
    .of(Yup.number())
    .min(1, 'Selecione pelo menos uma doca')
    .required('Selecione uma doca'),
  startDate: Yup.date()
    .typeError('Data inválida')
    .required('Informe a data de início')
    .test('weekdays-start', 'A data inicial não pode cair no final de semana', function (value) {
      if (this.parent.intervalType === 'weekdays' && value) {
        const day = value.getDay();
        if (day === 0 || day === 6) {
          return this.createError({ message: 'A data inicial não pode ser sábado ou domingo' });
        }
      }
      return true;
    }),
  endDate: Yup.date()
    .typeError('Data inválida')
    .required('Informe a data de término')
    .test({
      name: 'testEndDate',
      test: function (value) {
        try {
          const startDate = this.parent.startDate;
          const intervalType = this.parent.intervalType;

          if (!startDate || !value) return true;

          if (isBefore(value, startDate)) {
            throw new Error(
              'A data de término não pode ser anterior à data de início'
            );
          }

          if (intervalType === 'weekdays') {
            const day = value.getDay();
            if (day === 0 || day === 6) {
              throw new Error('A data final não pode ser sábado ou domingo');
            }
          }

          return true;
        } catch (error: any) {
          return this.createError({
            message: error?.message,
          });
        }
      },
    }),
  startTime: Yup.string().required('Informe a hora de início'),
  endTime: Yup.string().required('Informe a hora de término'),
  intervalType: Yup.string().required('O tipo de intervalo é obrigatório'),
});
